'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.geocodeLocations = exports.formatAddressKey = exports.formatAddress = exports.findLocations = exports.findLocationsModule = exports.SECTIONS = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _geocode = require('./geocode');

var _geocode2 = _interopRequireDefault(_geocode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SECTIONS = exports.SECTIONS = ['body', 'sidebar', 'footer'];

var findLocationsModule = exports.findLocationsModule = function findLocationsModule() {
  var modules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return modules.filter(function (module) {
    return module.type === 'locations';
  }).reduce(function (arr, module) {
    return arr.concat(module.locations.filter(function (location) {
      //console.log('incoming location', location);
      return !location.lat;
    }));
  }, []);
};

var sectionHasModules = function sectionHasModules(response) {
  return function (section) {
    return response[section] && response[section].length;
  };
};

var findLocations = exports.findLocations = function findLocations(response) {
  return SECTIONS.filter(sectionHasModules(response)).reduce(function (arr, section) {
    return arr.concat(findLocationsModule(response[section]));
  }, []);
};

var formatAddress = exports.formatAddress = function formatAddress(_ref) {
  var line1 = _ref.line1,
      line2 = _ref.line2,
      city = _ref.city,
      state = _ref.state,
      zip = _ref.zip;

  return line1 + ' ' + line2 + ' ' + city + ' ' + state + ' ' + zip;
};

var getAddress = function getAddress(address) {
  if (typeof address === 'string') {
    return address;
  }

  return formatAddress(address);
};

var formatAddressKey = exports.formatAddressKey = getAddress;

var geocodeLocations = exports.geocodeLocations = function geocodeLocations(locations) {
  return _promise2.default.all(locations.map(function (_ref2) {
    var address = _ref2.address;

    var formattedAddress = getAddress(address);
    return (0, _geocode2.default)(formattedAddress).then(function (location) {
      return {
        // pass an optional key, in case we want to use less
        // verbose storage within the data store
        key: formatAddressKey(address),
        address: formattedAddress,
        location: location
      };
    }).catch(function (err) {
      // A failed address should not ruin the entire Promise chain.
      // Display the successful locations and ignore the failures.
      console.error('could not geocode', address, err);
      return {};
    });
  }));
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/redux/middlewares/geocoding/utils.js
// module id = 449
// module chunks = 0